import { editorMap as iftiDraMap } from './ifti-dra';

export const editorMap = {
  ...iftiDraMap,
};
